import { NodeToolbar, NodeToolbarProps } from '@xyflow/react';
import { Paper, SxProps } from '@mui/material';
import React, { useMemo } from 'react';

interface CanvasNodeToolbarProps extends NodeToolbarProps {
  children: React.ReactNode;
  paperSx?: SxProps;
  hide?: boolean;
}

const defaultPaperStyles: SxProps = {
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  padding: '4px 4px',
  gap: '4px',
};

export const CanvasNodeToolbar = ({
  children,
  paperSx,
  hide: hide,
  ...nodeToolbarProps
}: CanvasNodeToolbarProps) => {
  const paperStyles = useMemo(
    () => ({ ...defaultPaperStyles, ...paperSx, opacity: hide ? 0 : 1 }),
    [hide, paperSx],
  );

  return (
    <NodeToolbar {...nodeToolbarProps}>
      <Paper sx={paperStyles} className="rich-text-editor-toolbar-item">
        {children}
      </Paper>
    </NodeToolbar>
  );
};
